module.exports = __webpack_public_path__ + "assets/a28bdaa860ce6051688fafac840f2f2f.png";